import { Link, useLocation } from 'react-router-dom';
import { Home, User, Calendar, MessageCircle } from 'lucide-react';

const WHATSAPP_URL = 'https://wa.me/306974994577?text=Hi!%20I%27m%20interested%20in%20a%20Santorini%20transfer.';

/**
 * Bottom Navigation Bar — visible ONLY on mobile (< md).
 * Always accessible: Home, About, Book, WhatsApp.
 */
export default function MobileBottomNav() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]"
      data-testid="mobile-bottom-nav"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="grid grid-cols-4 h-16">
        <Link
          to="/"
          className={`flex flex-col items-center justify-center gap-1 transition-colors ${
            isActive('/') ? 'text-[#0A2540]' : 'text-slate-500'
          }`}
          data-testid="mobile-nav-home"
        >
          <Home className="w-5 h-5" strokeWidth={isActive('/') ? 2.4 : 2} />
          <span className={`text-[10px] font-medium tracking-wide uppercase ${isActive('/') ? 'font-bold' : ''}`}>
            Home
          </span>
        </Link>

        <Link
          to="/about"
          className={`flex flex-col items-center justify-center gap-1 transition-colors ${
            isActive('/about') ? 'text-[#0A2540]' : 'text-slate-500'
          }`}
          data-testid="mobile-nav-about"
        >
          <User className="w-5 h-5" strokeWidth={isActive('/about') ? 2.4 : 2} />
          <span className={`text-[10px] font-medium tracking-wide uppercase ${isActive('/about') ? 'font-bold' : ''}`}>
            About
          </span>
        </Link>

        <Link
          to="/book"
          className={`flex flex-col items-center justify-center gap-1 transition-colors ${
            isActive('/book') ? 'text-[#0A2540]' : 'text-slate-500'
          }`}
          data-testid="mobile-nav-book"
        >
          <Calendar className="w-5 h-5" strokeWidth={isActive('/book') ? 2.4 : 2} />
          <span className={`text-[10px] font-medium tracking-wide uppercase ${isActive('/book') ? 'font-bold' : ''}`}>
            Book
          </span>
        </Link>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-1 text-[#25D366] transition-colors"
          data-testid="mobile-nav-whatsapp"
        >
          <MessageCircle className="w-5 h-5" strokeWidth={2} fill="#25D366" stroke="white" />
          <span className="text-[10px] font-medium tracking-wide uppercase">Chat</span>
        </a>
      </div>
    </nav>
  );
}
